export const CreateBlobUrl = (data) => {
  try {
    if (data) {
      var byteString = atob(data.split(',')[1]);
      var mimeString = data.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      return blob;
    }
    return;
  } catch (error) {
    console.error(error);
  }
};

export const hotFixCreateBlobUrl = (data) => {
  try {
    if (data?.startsWith?.('blob:')) {
      return data;
    } else {
      let blob = CreateBlobUrl(data);

      return URL.createObjectURL(blob);
    }
  } catch (error) {
    console.error(error);

    return '';
  }
};
